import { AxiosError } from 'axios';

import { ServiceResponse } from '../types/service-response.type';

export const getAuthToken = (): string => {
    const token = localStorage.getItem('accessToken');
    if (!token) return '';

    return `Bearer ${token}`;
};

export const handleResponseError = (error: AxiosError): ServiceResponse => {
    if (!error.response) {
        console.error('[!] Internet connection error');
        return {
            code: -999,
            message: 'Internet connection error',
        };
    }

    return error.response.data as ServiceResponse;
};

export const handleAxiosError = (error: AxiosError): ServiceResponse => {
    // Extraer información del error
    console.log('axioserror', error);

    if (!error.response) {
        console.error('[!] Internet connection error');
        return {
            code: -999,
            message: 'Internet connection error',
        };
    }

    // Diferent a 2xx
    if (error.response.status >= 400) {
        return {
            message: (error.response.data as { error: string }).error,
            code: error.response.status,
        };
    }
    return {
        code: -999,
        message: error.message,
    };
};

export const addQueryParams = (
    params: { [key: string]: any } | undefined
): string => {
    let inlineParams = '';
    if (!params) return inlineParams;
    const keys = Object.keys(params);
    let idx = 0;

    for (const key of keys) {
        if (!params[key] || params[key].toString().trim() === '') {
            continue;
        }

        if (idx === 0) {
            inlineParams += `?${key}=${params[key]}`;
        } else {
            inlineParams += `&${key}=${params[key]}`;
        }

        idx++;
    }

    return inlineParams;
};

export const buildEndpoint = (baseUrl: string, endpoint: string): string => {
    const url = new URL(baseUrl);
    url.pathname = url.pathname.replace(/\/$/, '') + endpoint;
    return url.toString();
};
